import {
    takeLatest,
    put,
    call,
    fork
    // all
} from "redux-saga/effects";
import { FacilityAccountService } from "services";
import { message } from "antd";
import { 
    createdFacilityAccount,
    failedCreateFacilityAccounts,
    fetchedFacilityAccount,
    failedFetchFacilityAccounts,
    fetchedFacilityAccountSupplyChains,
    failedFetchFacilityAccountSupplyChains,
    fetchFacilityAccountSupplyChains,
    updatedFacilityAccountSupplyChains,
    failedUpdateFacilityAccountSupplyChains,
    updateFacilityAccountSupplyChains
} from "./../actions";
import { ACCOUNT_FACILITY_ACTIONS } from "constants";

function* createFacilityAccount({payload}) {
    try {
        const { data,error } = yield call(FacilityAccountService.createFacility, payload.caseId, payload.accountData);
        if(!error) {
            yield put(createdFacilityAccount(payload.caseId, data));
            yield put(updateFacilityAccountSupplyChains(payload.caseId, payload.supplyChainData));
            message.success("Account Facility Created");
        }
    } catch(error) {
        message.error("Failed to Create Facility");
        yield put(failedCreateFacilityAccounts(error));
    }
}

function* getFacilityAccount({payload}) {
    try {
        const { data,error } = yield call(FacilityAccountService.getFacility, payload.caseId);
        if(!error) {
            yield put(fetchedFacilityAccount(payload.caseId, data));
        }
    } catch(error) {
        message.error("Failed to Fetch Facility");
        yield put(failedFetchFacilityAccounts(error));
    }
}

function* updateFacilityAccountSupplyChainsHandler({payload}) {
    try {
        message.loading("Updating Schemes... ", 0);
        const { data,error } = yield call(FacilityAccountService.updateSupplyChains, payload.caseId, payload.supplychainData);
        if(!error) {
            message.destroy();
            yield put(updatedFacilityAccountSupplyChains(payload.caseId, data));
            message.success("Scheme selection done. Please proceed with LOS to LMS.");
            yield put(fetchFacilityAccountSupplyChains(payload.caseId));
        } else {
            message.destroy();
            message.error("Failed to Update Schemes");
            yield put(failedUpdateFacilityAccountSupplyChains(error));
        }
    } catch(error) {
        message.destroy();
        message.error("Failed to Update Schemes");
        yield put(failedUpdateFacilityAccountSupplyChains(error));
    }
}

function* fetchFacilityAccountSupplyChainsHandler({payload}) {
    try {
        const { data, error } = yield call(FacilityAccountService.getSupplyChainList, payload.caseId);
        if(!error) {

            yield put(fetchedFacilityAccountSupplyChains(payload.caseId, data.results));
        }
    } catch(error) {
        message.error("Failed to Fetch Facility");
        yield put(failedFetchFacilityAccountSupplyChains(error));
    }
}

export default fork (function*() {
    yield takeLatest(
        ACCOUNT_FACILITY_ACTIONS.CREATE_FACILITY_ACCOUNT,
        createFacilityAccount
    );
    yield takeLatest(
        ACCOUNT_FACILITY_ACTIONS.FETCH_FACILITY_ACCOUNT,
        getFacilityAccount
    );
    yield takeLatest(
        ACCOUNT_FACILITY_ACTIONS.UPDATE_SUPPLY_CHAINS_LIST,
        updateFacilityAccountSupplyChainsHandler
    );
    yield takeLatest(
        ACCOUNT_FACILITY_ACTIONS.FETCH_SUPPLY_CHAINS_LIST,
        fetchFacilityAccountSupplyChainsHandler
    );
});